/**
 * @fileoverview Settings page with account info and integrations.
 * @module features/settings/pages/SettingsPage
 */

import { ReactElement } from 'react'
import { ScrollReveal } from '@/shared/components/ui'
import { AccountInfoCard } from '@/features/settings/components/AccountInfoCard'
import { AdPlatformsCard } from '@/features/settings/components/AdPlatformsCard'
import { OrderSourcesCard } from '@/features/settings/components/OrderSourcesCard'
import { StoresCard } from '@/features/settings/components/StoresCard'
import { BankConnectionsCard } from '@/features/settings/components/BankConnectionsCard'
import { ConnectClaudeCard } from '@/features/mcp/components/ConnectClaudeCard'

/**
 * SettingsPage
 *
 * Displays account settings and integrations management.
 * Organized by data flow: Ad Platforms, Order Sources, Stores, Banking.
 *
 * @component
 */
export function SettingsPage(): ReactElement {
  return (
    <div className="min-h-screen pt-18">
      <div className="max-w-screen-xl mx-auto px-4 lg:px-8 py-8 space-y-8">
        {/* Row 1: Account Info + Ad Platforms */}
        <ScrollReveal blur>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <AccountInfoCard />
            <AdPlatformsCard />
          </div>
        </ScrollReveal>

        {/* Row 2: Order Sources + Stores */}
        <ScrollReveal blur>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <OrderSourcesCard />
            <StoresCard />
          </div>
        </ScrollReveal>

        {/* Row 3: Banking + Connect Claude */}
        <ScrollReveal blur>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <BankConnectionsCard />
            <ConnectClaudeCard />
          </div>
        </ScrollReveal>
      </div>
    </div>
  )
}
